export enum AliveCorAcuity {
  Stable = 'Stable',
  NeedsReview = 'Needs review',
  Serious = 'Serious',
  NotAcceptable = 'Not acceptable',
}
